module.exports = __webpack_public_path__ + "img/role-senior.480163e9.png";